import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const mobileCss = config.css.mobile;

const cssXL = {
  root: null
};
const cssXS = {
  root: {
    marginTop:
      -mobileCss.paddingBetweenHeaderbarAndFirstContent +
      mobileCss.paddingBetweenHeaderbarAndFirstContentForLookbook
  }
};

class LookbookListView extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    callNextListFn: PropTypes.func.isRequired
  };

  render() {
    const { list, isLoading, isEnd, callNextListFn } = this.props;
    const css = getDeviceType() === "mobile" ? cssXS : cssXL;

    return (
      <div style={css.root}>
        <OutfitListView
          list={list}
          isLoading={isLoading}
          isEnd={isEnd}
          callNextListFn={callNextListFn}
          emptyListText={<TXT name="msg_emptyListLookbook" />}
        />
      </div>
    );
  }
}

export default LookbookListView;
